// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* mobile first styles */

main {
  --page-padding: var(--page-padding-mobile);

  padding: var(--page-padding);
}

/* tablet or larger */
@media only screen and (min-width: 767px) and (min-height: 551px) {
  main {
    --page-padding: var(--page-padding-tablet);
  }
}

/* desktop or larger */
@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {
  main {
    --page-padding: var(--page-padding-desktop);
  }
}
`, "",{"version":3,"sources":["webpack://./src/css-modules/main.css"],"names":[],"mappings":"AAAA,wBAAwB;;AAExB;EACE,0CAA0C;;EAE1C,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE;IACE,0CAA0C;EAC5C;AACF;;AAEA,sBAAsB;AACtB;EACE;IACE,2CAA2C;EAC7C;AACF","sourcesContent":["/* mobile first styles */\r\n\r\nmain {\r\n  --page-padding: var(--page-padding-mobile);\r\n\r\n  padding: var(--page-padding);\r\n}\r\n\r\n/* tablet or larger */\r\n@media only screen and (min-width: 767px) and (min-height: 551px) {\r\n  main {\r\n    --page-padding: var(--page-padding-tablet);\r\n  }\r\n}\r\n\r\n/* desktop or larger */\r\n@media only screen and (min-width: 961px) and (orientation: landscape) and (min-height: 551px) {\r\n  main {\r\n    --page-padding: var(--page-padding-desktop);\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
